import Actions from "../actions";
import { produce } from "immer";

const initialState = {
  categoriesSelectList: [],
  subCategoriesSelectList: [],
  category: {},
  categories: {},
  selectedcategoryId: "",
};

const categories = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_CATEGORIES_SELECT_LIST: {
      draft.categoriesSelectList = payload?.categoriesSelectList?.map(
        (element) => ({
          ...element,
          value: element?._id,
          label: element?.name,
          subCategories: element?.subcategories,
        })
      );
      break;
    }

    case Actions.GET_SUB_CATEGORIES_SELECT_LIST: {
      draft.subCategoriesSelectList = payload?.subCategoriesSelectList?.map(
        (element) => ({ value: element._id, label: element.name })
      );
      break;
    }

    case Actions.GET_CATEGORIES_LIST: {
      draft.categories = payload?.categories;
      break;
    }

    case Actions.SELECTED_CATEGORIES_ID: {
      draft.selectedcategoryId = payload?.selectedcategoryId;
      break;
    }

    case Actions.GET_CATEGORIES_BY_ID: {
      draft.category = payload?.category;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default categories;
